import PlainMenu from "../src/plain/PlainMenu.js";
export default class ElixMenu extends PlainMenu {}
customElements.define("elix-menu", ElixMenu);
